const isMobile = () => {
  return navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i)
}

export { isMobile }
